export function RegisterVoxelSnippets(builder) {
    builder.snippets.create({
        id: "#dve_solid_vertex",
        body: {
            GLSL: () => `@standard_position`,
        },
    });
    builder.snippets.create({
        id: "#dve_solid_frag",
        body: {
            GLSL: () => `@standard_color`,
        },
    });
    builder.snippets.create({
        id: "#dve_flora_vertex",
        body: {
            GLSL: () => `vec3 p = position;

#ifdef INSTANCES
      mat4 finalWorld = mat4(world0,world1,world2,world3); 

      vDistance = 0.;
      mipMapLevel = 0.;

      finalWorld[3].xyz += worldOrigin.xyz;
      gl_Position = viewProjection *   finalWorld * vec4(position, 1.0);  
#endif      
#ifndef INSTANCES
    vec4 worldPosition = world * vec4(p , 1.0);

    if(doEffects == 1.){
      if(vDistance < 50.) {
        if(VOXEL[1].y == 1.) {
          p.xz = dve_crossed_panel_wind_anim(worldPosition, p).xz;
        }
        if(VOXEL[1].y == 2.) {
          p.xz = dve_panel_wind_anim(worldPosition, p).xz;
        }
        if(VOXEL[1].y == 3.) {
          p.xz = dve_box_wind_anim(worldPosition, p).xz;
        }
      }
    }
    gl_Position = viewProjection * world * vec4(p, 1.0); 
#endif
  
  `,
        },
    });
    builder.snippets.create({
        id: "#dve_flora_frag",
        body: {
            GLSL: () => `@standard_color`,
        },
    });
    builder.snippets.create({
        id: "#dve_liquid_vertex",
        body: {
            GLSL: () => `
  vFlow = 0.;
  if(VOXEL[1].y == 1.) {
    vFlow = 1.;
  }
  if(VOXEL[1].y == 2.) {
    vFlow = -1.;
  }


#ifdef INSTANCES
  mat4 finalWorld = mat4(world0,world1,world2,world3); 

  vDistance = 0.;
  mipMapLevel = 0.;

  finalWorld[3].xyz += worldOrigin.xyz;
  gl_Position = viewProjection *   finalWorld * vec4(position, 1.0);  
#endif  

#ifndef INSTANCES
  vec3 p = position;
  vec4 worldPosition = world * vec4(p , 1.0);
  if(doEffects == 1.){
  float height = fbm(worldPosition.xz * 0.08 + time);
    p.y += (height * 0.03) - .05;
   }
  
  gl_Position = viewProjection * world * vec4(p, 1.0); 
#endif
  `,
        },
    });
    builder.snippets.create({
        id: "#dve_liquid_frag",
        body: {
            GLSL: () => `
  vec4 rgb = getBaseColor(vec2(0.,time * -4. * vFlow));
  rgb = getColor(rgb);
  vec4 mixLight = getLight(rgb);
  vec3 finalColor = doFog(mixLight);
  FragColor = vec4(finalColor.rgb , .6 );`,
        },
    });
}
